import styled from "styled-components";

export const Container = styled.footer`
    padding: 7rem 2rem 2rem;

    background: ${({ theme }) => theme.colors.background};
`;

export const Top = styled.div`
    max-width: 1200px;
    margin: 0 auto;

    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 3rem;

    padding: 3rem;

    background: rgba(255, 255, 255, .03);
    border: 1px solid rgba(255, 255, 255, .08);
    border-radius: 24px;

    @media (max-width: 992px) {
        flex-direction: column;
        text-align: center;
    }
`;

export const Brand = styled.div`
    max-width: 520px;
`;

export const Title = styled.h2`
    color: ${({ theme }) => theme.colors.white};

    font-size: clamp(2rem, 5vw, 3rem);

    margin-bottom: 1rem;
`;

export const Description = styled.p`
    color: ${({ theme }) => theme.colors.gray};

    line-height: 1.8;
`;

export const Button = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: .7rem;
    
    padding: 1.15rem 2.5rem;
    font-size: 1rem;

    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.md};

    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.background};

    font-weight: 600;

    cursor: pointer;

    transition: .3s ease;

    &:hover {
        transform: translateY(-3px);
    }
`;

export const Divider = styled.div`
    max-width: 1200px;

    height: 1px;

    margin: 4rem auto;

    background: rgba(255, 255, 255, .08);
`;

export const Content = styled.div`
    max-width: 1200px;
    margin: 0 auto;

    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 4rem;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
    }
`;

export const Links = styled.nav`
    display: flex;
    flex-direction: column;

    gap: 1rem;
`;

export const Link = styled.a`
    color: ${({ theme }) => theme.colors.gray};

    text-decoration: none;

    transition: color .3s ease;

    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

export const Bottom = styled.div`
    max-width: 1200px;

    margin: 0 auto;

    display: flex;
    justify-content: center;
`;

export const Copyright = styled.p`
    color: ${({ theme }) => theme.colors.gray};
    font-size: .9rem;
    line-height: 1.7;
    margin-top: .4rem;

    @media (max-width: 768px) {
        text-align: center;
    }
`;

export const Socials = styled.div`
    display: flex;

    margin-top: 0;

    gap: 1rem;

    @media (max-width: 768px) {
        justify-content: center;
    }

`;

export const SocialLink = styled.a`
    width: 52px;
    height: 52px;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;

    background: rgba(255, 255, 255, .04);

    border: 1px solid rgba(255, 255, 255, .08);

    color: ${({ theme }) => theme.colors.gray};

    transition: .3s ease;

    &:hover {
        transform: translateY(-4px);

        color: ${({ theme }) => theme.colors.primary};

        border-color: ${({ theme }) => theme.colors.primary};

        box-shadow: 0 15px 35px rgba(127, 191, 208, .25);
    }
`;

export const TitleFooter = styled.h3`
    color: ${({ theme }) => theme.colors.white};
    margin-bottom: .7rem;
    font-size: 1.2rem;
`;

export const Subtitle = styled.h5`
    color: ${({ theme }) => theme.colors.white};
    margin-bottom: 1rem;
    font-size: 1rem;
`;